var map = {
	"./img_1.jpeg": 94317,
	"./img_2.jpg": 12793,
	"./img_3.jpg": 53327,
	"./img_4.jpg": 34162,
	"./img_5.jpeg": 94540,
	"./img_6.jpg": 29082,
	"./img_7.jpeg": 42028,
	"./img_8.jpg": 86876
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27743;